import MicroModal from 'micromodal';

import {trapFocus, removeTrapFocus} from '../vendor/theme-scripts/theme-a11y';

const selectors = {
  focusable: 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
};

export function modal(unique) {
  const uniqueID = `data-popup-${unique}`;
  MicroModal.init({
    openTrigger: uniqueID,
    disableScroll: true,
    onShow: (modal, el, event) => {
      event.preventDefault();
      const firstFocus = modal.querySelector(selectors.focusable);
      trapFocus(modal, {elementToFocus: firstFocus});
    },
    onClose: (modal, el, event) => {
      event.preventDefault();
      removeTrapFocus();
      el.focus();
    },
  });
}
